<template>
  <div class="educationPages">
    <div class="educationPages_top">
      <van-icon style="position: absolute; left: 10px" size="25" name="arrow-left" @click="to()" />
      <div class="my">不通过原因</div>
    </div>
    <div class="educationPages_bootm">
      <p style="
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          width: 94%;
          margin: 42px auto;
        ">
        由于以下原因,暂时无法通过
      </p>
      <div class="tect">
        <p>1、账号内资产已结清。</p>
        <p>2、账号存在无未完成订单。</p>
        <p>3、账号未解除与第三方产品的绑定关系或授权登录关系。</p>
        <p>4、账号存在未完结的服务</p>
      </div>
      <div style="margin: 10px 0 20px; width: 94%; margin: 20px auto">
        <van-button round block type="info" native-type="submit" class="form_btn" to="information">确定</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "educationPages",
  data() {
    return {};
  },
  methods: {
    to() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.educationPages {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;

  .educationPages_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }

    .determine {
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      position: absolute;
      right: 15px;
    }
  }

  .educationPages_bootm {
    width: 100%;
    height: 100%;

    .tect {
      width: 94%;
      height: 142px;
      background: #ffffff;
      border-radius: 8px;
      margin: 0 auto;
      padding: 0px 0px 0px 12px;
      overflow: hidden;

      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-top: 5px;
      }
    }
  }
}
</style>